import { gql } from '@apollo/client';

export const CREATIVES_FRAGMENTS = gql`
  fragment creatives on BaseCreativeV5 {
    __typename
    id
    creativeLibraryId
    name
    review
    status
    createdAt
    updatedAt
    type
    assetTagList {
      id
      value
      description
      displayName
    }
    rejectionReason
    rejectionReasonDetails
    ... on AdSelectorSlateCreativeV5 {
      logo {
        id
      }
      headline
      randomOrder
      optionList {
        caption
        adSelectorVideoCreativeId
        thumbnail {
          id
          name
          createdAt
          countryReviews {
            country
            status
            allowedPublishers
            declines {
              reason
              internalComment
              externalComment
            }
          }
          transcode {
            id
            status
            name
            message
            failureMessage
            details
            playbackId
            mediaDeliveryId
          }
          subClass
        }
        index
      }
      voiceoverUrl
    }
    ... on AdSelectorVideoCreativeV5 {
      video {
        id
      }
    }
    ... on BrightlineCreativeV5 {
      url
      vpaid
      videoAssetList {
        id
      }
      template
      featureList
    }
    ... on GatewayGoCreativeV5 {
      offerImage {
        id
      }
      video {
        id
      }
      livingRoomCopy
      emailSubject
      emailBody
      pushTitle
      pushBody
      destinationUrl
    }
    ... on InnovidCreativeV5 {
      url
      vpaid
      videoAssetList {
        id
      }
      template
      featureList
    }
    ... on MagniteCreativeV5 {
      url
      vpaid
      videoAssetList {
        id
      }
      adSourceId
    }
    ... on DraxCreativeV5 {
      url
      vpaid
      videoAssetList {
        id
      }
    }
    ... on PauseCreativeV5 {
      altText
      image {
        id
      }
      accent {
        r
        g
        b
      }
      status
    }
    ... on SlateCreativeV5 {
      slate {
        id
      }
    }
    ... on VASTVideoCreativeV5 {
      url
      vpaid
      videoAssetList {
        id
        asset2 {
          name
        }
      }
    }
    ... on VideoCreativeV5 {
      video {
        id
      }
    }
    ... on InstreamDxcCreativeV5 {
      video {
        id
      }
      templateAssetList {
        id
      }
      experienceId
    }
    ... on OutstreamDxcCreativeV5 {
      templateAssetList {
        id
      }
      experienceId
    }
  }
`;
